/**
 * Which way in worked last time.
 *
 * The identity providers differ in how long they remember a visitor: Google
 * keeps a browser session and returns almost instantly, Apple asks again on
 * most round trips. Neither is ours to change, so the sign-in block does the
 * one thing that is — it remembers which door the visitor used, puts it first
 * and says so, instead of making them find it again every time.
 */

export type SignInMethod = "google" | "apple" | "microsoft" | "email";

const STORAGE_KEY = "syncani.last-sign-in";

function isMethod(value: unknown): value is SignInMethod {
  return (
    value === "google" ||
    value === "apple" ||
    value === "microsoft" ||
    value === "email"
  );
}

export function readLastSignIn(): SignInMethod | null {
  if (typeof window === "undefined") return null;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return isMethod(stored) ? stored : null;
  } catch {
    return null;
  }
}

export function rememberSignIn(method: SignInMethod): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, method);
  } catch {
    // A browser that refuses storage simply forgets; nothing here is required.
  }
}
